var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Row', {
    staticClass: "app_detail_tab1"
  }, [_c('Col', {
    staticClass: "a_col",
    attrs: {
      "span": "10"
    }
  }, [_c('span', {
    staticClass: "lable"
  }, [_vm._v($t("ts2bfn5", "应用名称："))]), _c('span', [_vm._v(_vm._s(_vm.detail.name))])]), _c('Col', {
    staticClass: "a_col",
    attrs: {
      "span": "14"
    }
  }, [_c('span', {
    staticClass: "lable"
  }, [_vm._v($t("twfkrf5", "应用状态："))]), _c('i-switch', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "size": "large",
      "loading": _vm.loading,
      "true-value": "F",
      "false-value": "T"
    },
    on: {
      "on-change": _vm.changeConfig
    },
    model: {
      value: _vm.detail.isHalt,
      callback: function ($$v) {
        _vm.$set(_vm.detail, "isHalt", $$v);
      },
      expression: "detail.isHalt"
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v($t("gmcv2", "开启"))]), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v($t("eod62", "关闭"))])])], 1), _c('Col', {
    staticClass: "a_col",
    attrs: {
      "span": "10"
    }
  }, [_c('span', {
    staticClass: "lable"
  }, [_vm._v($t("d9svl3", "图标："))]), _c('span', {
    staticClass: "v_img"
  }, [_c('img', {
    attrs: {
      "src": _vm.detail.icon,
      "alt": ""
    }
  })])]), _c('Col', {
    staticClass: "a_col",
    attrs: {
      "span": "14"
    }
  }, [_c('span', {
    staticClass: "lable"
  }, [_vm._v($t("t7tsfh5", "使用人员："))]), _c('LineOrgTag', {
    attrs: {
      "list": _vm.scopeList
    },
    on: {
      "change": _vm.openAddOrgUser
    }
  })], 1), _c('Col', {
    staticClass: "a_col",
    attrs: {
      "span": "10"
    }
  }, [_c('span', {
    staticClass: "lable"
  }, [_vm._v($t("gc9h0p7", "应用安全等级："))]), _c('span', [_c('Rate', {
    attrs: {
      "count": 3,
      "show-text": "",
      "clearable": ""
    },
    on: {
      "on-change": _vm.setConfig
    },
    model: {
      value: _vm.detail.securityLevel,
      callback: function ($$v) {
        _vm.$set(_vm.detail, "securityLevel", $$v);
      },
      expression: "detail.securityLevel"
    }
  })], 1)]), _vm._language ? _c('Col', {
    staticClass: "a_col",
    attrs: {
      "span": "14"
    }
  }, [_c('span', {
    staticClass: "lable"
  }, [_vm._v($t("l6p533", "语言："))]), _c('Select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "transfer": "",
      "value": _vm.languageValue
    },
    on: {
      "on-change": _vm.onChangeLanguage
    }
  }, _vm._l(_vm.languageList, function (item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.title))]);
  }), 1)], 1) : _vm._e(), _vm._showDown ? _c('Col', {
    staticClass: "a_col",
    attrs: {
      "span": "24"
    }
  }, [_c('span', {
    staticClass: "lable"
  }, [_vm._v($t("vjjuo85", "下载地址："))]), _c('span', {
    staticClass: "lable_down_address",
    on: {
      "click": _vm.onChangeEditAddress
    }
  }, [_vm._v(" " + _vm._s(_vm.detail.downloadUrl) + " ")])]) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };